import { css } from '@emotion/css';
import React, { useEffect } from 'react';
import { styles } from './styles';
import SubscriptionOptions from './SubscriptionOptions';
import PlusValue from './SVGs/plus-value.svg';
import AragLogo from './SVGs/arag-logo.png';
import { TrackingEvents } from '@/tracking/trackingEvents';
import { report } from '@/tracking/tracking';
import { Msg } from '@/i18n';
import { useHasMeinPlus } from '@/customHooks/useHasMeinPlus.hook';
import useWohnenPlusUpsellContentExperimentConfig from '@/customHooks/useWohnenPlusUpsellContentExperimentConfig.hook';
import useOptimizelyExperimentVariation from '@/optimizely/useOptimizelyExperimentVariation';
import { useExperimentLanguage } from '@/customHooks/useExperimentLanguage.hook';

const WohnenPlusUpsellContent: React.FC = () => {
  const isMeinPlus = useHasMeinPlus();
  const { configurationIds } = useWohnenPlusUpsellContentExperimentConfig();
  const showPartnerLogo = useOptimizelyExperimentVariation('upsell_modal_partner_logo', 'variation1');
  const { langKey } = useExperimentLanguage();

  useEffect(() => {
    report(TrackingEvents.WOHNEN_PLUS_UPSELL.PAGE_VISITED, isMeinPlus);
  }, [report]);

  return (
    <div data-testid='wohnenUpsellModal' className={css('absolute-reference', styles.modal)}>
      <div className='display-flex grid-justify-space-between grid-align-start margin-bottom-l palm-margin-bottom-xl'>
        <div className={css(styles.headersContainer)}>
          <div className='font-heading-small-bold margin-none'>
            <Msg
              id={`welcomeModal.wohnenUpsell.${langKey}.header`}
              defaultMessage='Dein Upgrade für mehr Miet-Sicherheit: '
            />
            <span className='font-nowrap'>
              <Msg id={`welcomeModal.wohnenUpsell.${langKey}.wohnenPlusS`} defaultMessage='Wohnen+ S' />
            </span>
          </div>
          <div className='font-body-large-regular'>
            <Msg
              id={`welcomeModal.wohnenUpsell.${langKey}.subheader`}
              defaultMessage='Mit Suchen+ für Miete erhältst du bis zu 30% Willkommensrabatt.'
              values={{
                percentage: configurationIds.DISCOUNT_PERCENTAGE,
              }}
            />
          </div>
        </div>
        <img className={`margin-left-l ${styles.plusValueImg}`} src={PlusValue} height={40} alt='Plus' />
      </div>
      <div className='margin-bottom-l palm-margin-bottom-xl'>
        <div className={`font-body-large-regular palm-hide ${styles.explanationContainer}`}>
          <Msg
            id={`welcomeModal.wohnenUpsell.${langKey}.explanationText`}
            defaultMessage='Ob Kaution, Mietminderung oder Nebenkosten...'
            values={{
              lowestMonthlyCost: configurationIds.MAX_VALUE,
            }}
          />
        </div>
        {showPartnerLogo && (
          <div className={styles.aragPartnershipContainer}>
            <img src={AragLogo} height={32} alt='ARAG logo' />
            <div className='font-body-large-regular'>
              <Msg
                id={`welcomeModal.wohnenUpsell.${langKey}.aragPartnership`}
                defaultMessage='In Partnerschaft mit ARAG'
              />
            </div>
          </div>
        )}
      </div>
      <SubscriptionOptions />
    </div>
  );
};

export default WohnenPlusUpsellContent;
